var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"auto","elevation":"0"}},[_c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('v-img',{staticClass:"mx-2",attrs:{"width":"auto","src":"https://www.risoul.com.mx/hs-fs/hubfs/Banner_Asesoria.png?width=257&name=Banner_Asesoria.png"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }